class CsrfToken {
    constructor() {
        const csrfTokenName = window.csrfTokenName;
        const csrfInputs = document.querySelectorAll('input[name=' + csrfTokenName + ']');

        csrfInputs.forEach(input => {
            this.getCsrfValue('/actions/alandsbanken/alandsbanken/csrf-token').then((data) => {
                input.value = data.csrfToken;
            });
        });
    }

    async getCsrfValue(url = "") {
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.json();
    }
}

new CsrfToken();